import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

export const PrivateCalendarsIcon: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" viewBox="0 0 23 24" fill="none">
      <path 
        d="M1.71216 22.8571C1.25558 22.8571 0.856079 22.6857 0.513648 22.3429C0.171216 22 0 21.6 0 21.1429V3.42857C0 2.97143 0.171216 2.57143 0.513648 2.22857C0.856079 1.88571 1.25558 1.71429 1.71216 1.71429H3.567V0H5.42184V1.71429H15.1241V0H16.9789V1.71429H18.8337C19.2903 1.71429 19.6898 1.88571 20.0323 2.22857C20.3747 2.57143 20.5459 2.97143 20.5459 3.42857V12.0286H18.8337V8.85714H1.71216V21.1429H10.8151V22.8571H1.71216ZM21.9442 16.6L19.9181 14.5714L20.7457 13.7429C20.8978 13.5905 21.0976 13.5143 21.3449 13.5143C21.5922 13.5143 21.792 13.5905 21.9442 13.7429L22.7717 14.5714C22.9239 14.7238 23 14.9238 23 15.1714C23 15.419 22.9239 15.619 22.7717 15.7714L21.9442 16.6ZM12.5273 24V21.9714L18.6911 15.8L20.7171 17.8286L14.5533 24H12.5273ZM1.71216 7.14286H18.8337V3.42857H1.71216V7.14286ZM1.71216 7.14286V3.42857V7.14286Z" 
        fill="#3273E1" 
        fillOpacity="0.85" 
      />
    </svg>
  </SvgWrapper>
);